import { Box } from "@chakra-ui/react";

interface TimezoneHeaderProps {
  timezone?: string;
  timeColumnWidth: number;
  slotHeight: number;
}

export default function TimezoneHeader({ timezone, timeColumnWidth, slotHeight }: TimezoneHeaderProps) {
  const getTimezone = () => {
    const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone; // ✅ use passed timezone or fallback
    const now = new Date();

    // Get the abbreviated timezone (e.g., "PST", "EST")
    const shortTimezone = now.toLocaleDateString("en-US", {
      timeZoneName: "short",
      timeZone: tz,
    }).split(", ")[1];

    // If we can get the short name, use it, otherwise use city name
    if (shortTimezone && shortTimezone.length <= 4) {
      return shortTimezone;
    }

    // Fallback to city name from timezone
    const cityName = tz.split("/")[1]?.replace(/_/g, " ");
    return cityName || tz;
  };

  return (
    <Box
      width={`${timeColumnWidth}px`}
      height={`${slotHeight}px`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRight="1px solid #eee"
      bg="gray.50"
      fontSize="xs"
      color="gray.600"
      fontWeight="medium"
    >
      {getTimezone()}
    </Box>
  );
}
